import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/* CSS */
import styles from './style/statDetails.module.css';

/* Icons */
import chevron_down from '../../../assets/icons/chevron_down.svg';

const MostActiveMonthDetail = ({ months, maxDays }) => {
    const navigate = useNavigate();

    // Track which months are expanded. Start with the most-active month(s) open.
    // NOTE: hooks must run before any early return, or React sees a different
    // hook count between renders (Rules of Hooks).
    const [openMonths, setOpenMonths] = useState(
        () => (months || []).filter(m => m.days === maxDays).map(m => m.monthIndex)
    );

    const toggleMonth = (monthIndex) => {
        setOpenMonths(prev =>
            prev.includes(monthIndex)
                ? prev.filter(i => i !== monthIndex)   // it's open → remove (collapse)
                : [...prev, monthIndex]                // it's closed → add (expand)
        );
    };

    if (!months || months.length === 0) {
        return (
            <div className={styles.empty}>
                No travel months yet
            </div>
        );
    }

    return (
        <div className={styles.list}>
            {months.map((month) => {
                const isOpen = openMonths.includes(month.monthIndex);

                return (
                    <div className={styles.monthCard} key={month.monthIndex}>
                        {/* Header */}
                        <button
                            type="button"
                            className={styles.monthHeader}
                            onClick={() => toggleMonth(month.monthIndex)}
                            aria-expanded={isOpen}
                        >
                            <span className={styles.monthName}>{month.monthName}</span>
                            <span className={styles.monthMeta}>
                                <span className={styles.monthDays}>{`${month.days} ${month.days === 1 ? 'day' : 'days'} of travel`}</span>
                                <img
                                    src={chevron_down}
                                    alt=""
                                    className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
                                />
                            </span>
                        </button>

                        {/* Trips */}
                        {isOpen && (
                            <div className={styles.monthTrips}>
                                {month.trips.map((trip) => (
                                    <button
                                        key={trip.id}
                                        type="button"
                                        className={styles.tripBox}
                                        onClick={() => navigate(`/trip/${trip.id}`)}
                                        aria-label={`Open ${trip.title}`}
                                    >
                                        <div className={styles.rowTitle}>{trip.title}</div>
                                        <div className={styles.rowSub}>{trip.segmentLabel}</div>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default MostActiveMonthDetail;